// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3vVEz","title":"InfoRow_title__3fzi3"};